import React, { useEffect, useState } from "react";
import { Box, Flex, Image } from "rebass";
import { Label } from "@rebass/forms";
import { theme } from "../utils";
import { Avatar } from "../components";
import { Settings } from "../components/settings";
import logoImage from "../static/images/hernoLogo333.png";
import "./style.css";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BsColumnsGap, BsCurrencyEuro } from "react-icons/bs";
import { RxHamburgerMenu } from "react-icons/rx";
import { Price } from "../components/common/Price";
import {
  systemActions,
  userActions,
  yodaAgentActions,
  yodaOrdersActions,
} from "../logic/actions";
import { getLocalizedString } from "../utils";
import Select, { components } from "react-select";
import ChevronDown from "../icons/ChevronDown";
import Notify from "../../src/icons/Notify";
import Whishlist from "../../src/icons/Whishlist";
//DO NOT DELETE
import Navbar from "../components/Navbar";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { IconContext } from "react-icons";
import SwitchCustom from "react-switch";
import config from "../utils/globalConfig";
import HeaderFvl from "./HeaderFvl";
import useResponsive from "../hooks/useResponsive";
import logoCondensed from "../static/images/logoCondensed.svg";
import Tooltip from "../components/common/Tooltip";
import InfoButton from "../components/common/InfoButton";
import MinicartButton from "../components/common/MiniCartButton";
import { fill } from "lodash";

const Header = ({ collapsed, setCollapsed }) => {
  const dispatch = useDispatch();
  const navigate = useHistory();
  const { budget } = useSelector((state) => state.yodaBudget);
  const { order } = useSelector((state) => state.yodaOrders);
  const [changeAgentPermission, setChangeAgentPermission] = useState(false);
  const [adminDraftOrders, setAdminDraftOrders] = useState(false);
  const [changeCustomerPermission, setChangeCustomerPermission] =
    useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();
  const headerHeight = 50;
  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);

  const languages = {
    ITA: {
      name: "ITA",
    },
    ENG: {
      name: "ENG",
    },
  };

  const { hidePrice } = useSelector((state) => state.system);
  const { me } = useSelector((state) => state.yodaStakeholders);

  const { isMobile, isDesktopLg, isDesktopXl, type } = useResponsive();

  const changeHidePrice = () => {
    localStorage.setItem("hidePrice", !hidePrice);
    if (hidePrice) {
      dispatch(systemActions.setHidePrice(false));
    } else {
      dispatch(systemActions.setHidePrice(true));
    }
  };

  const toggleSettings = () => {
    setShowSettings(!showSettings);
  };

  const updateLanguage = (event) => {
    localStorage.setItem("B2BLanguage", event.value);
    dispatch(yodaOrdersActions.changeLanguage(event.value));
    navigate.push(navigate.location.pathname);
  };

  useEffect(() => {
    if (me?.role) {
      if (me?.role.includes?.("CustomerCare")) {
        setAdminDraftOrders(true);
        setChangeAgentPermission(true);
        setChangeCustomerPermission(true);
      } else if (me.role == "Agents") {
        dispatch(yodaAgentActions.getOne(me.id));
        setAdminDraftOrders(false);
        setChangeAgentPermission(false);
        setChangeCustomerPermission(true);
        localStorage.setItem("selectedAgent", me.id);
      } else if (me?.role.includes?.("Customer")) {
        setAdminDraftOrders(false);
        setChangeAgentPermission(false);
        setChangeCustomerPermission(false);
        localStorage.setItem("selectedCustomer", me.id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me]);

  let tmpLanguageValue = localStorage.getItem("B2BLanguage");
  var languageValue;

  if (tmpLanguageValue) {
    languageValue = {
      key: tmpLanguageValue,
      label: tmpLanguageValue,
    };
  } else {
    languageValue = {
      key: "ITA",
      label: "ITA",
    };

    localStorage.setItem("B2BLanguage", "ITA");
  }

  const NavDivider = () => (
    <Box
      sx={{
        height: "14px",
        my: "auto",
        mx: "3px",
        borderLeft: "1px solid #fff",
      }}
    ></Box>
  );
  return (
    <>
      {config.FVL && !isMobile && <HeaderFvl />}
      <Flex
        style={{
          width: "100%",
          position: "relative",
          display: config.FVL && !isMobile && "none",
        }}
      >
        {type.tablet || type.mobile || !(isDesktopLg || isDesktopXl) ? (
          <Flex
            style={{ width: "100%", position: "relative" }}
            sx={{
              "&": {
                display: "block",
              },
            }}
          >
            <Flex
              bg={theme.background}
              fontSize={theme.textTiny}
              style={{
                position: "relative",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Flex
                height={headerHeight}
                maxHeight={headerHeight}
                flex={1}
                fontSize={theme.textTiny}
                alignItems="center"
              >
                <IconContext.Provider value={{ color: "undefined" }}>
                  <div
                    className="navbar"
                    style={{
                      backgroundColor: "#232323",
                      width: "40px",
                      height: "40px",
                      marginRight: "15px",
                    }}
                  >
                    <RxHamburgerMenu
                      style={{ marginLeft: "5px" }}
                      onClick={showSidebar}
                      color="white"
                      size="30px"
                    />
                  </div>
                  <nav
                    className={sidebar ? "nav-menu active" : "nav-menu"}
                    style={{ zIndex: 10, backgroundColor: "#232323" }}
                  >
                    <ul className="nav-menu-items" onClick={showSidebar}>
                      <li
                        className="navbar-toggle"
                        style={{ backgroundColor: "#232323", height: "50px" }}
                      >
                        <AiIcons.AiOutlineClose
                          color="white"
                          size="30px"
                          style={{ marginLeft: "8px" }}
                        />
                      </li>
                      {me && (
                        <Flex
                          px="10px"
                          style={{
                            gap: "5px",
                            borderBottom: "0.5px solid #303130",
                          }}
                          alignItems="center"
                          height="40px"
                          bg="#303130"
                        >
                          <Avatar
                            id="avatar"
                            name={`${me?.firstName} ${me?.lastName}`}
                            mr={2}
                          />
                          <Label fontSize="14px" color="white">{`${
                            me?.firstName ? me?.firstName : ""
                          } ${me?.lastName}`}</Label>
                        </Flex>
                      )}

                      {adminDraftOrders && (
                        <Flex
                          px="10px"
                          pb="5px"
                          style={{
                            gap: "5px",
                            borderBottom: "0.5px solid #303130",
                          }}
                          alignItems="center"
                          height="40px"
                        >
                          <Link to="/adminOrders">
                            <Label
                              fontSize="14px"
                              color="white"
                              marginLeft="40px"
                            >
                              {getLocalizedString("ADMIN-DRAFT ORDER")}
                            </Label>
                          </Link>
                        </Flex>
                      )}

                      {changeAgentPermission && (
                        <Flex
                          px="10px"
                          pb="5px"
                          style={{
                            gap: "5px",
                            borderBottom: "0.5px solid #303130",
                          }}
                          alignItems="center"
                          height="40px"
                        >
                          <Link to="/agents">
                            <Label
                              fontSize="14px"
                              color="white"
                              marginLeft="40px"
                            >
                              {getLocalizedString("CAMBIA AGENTE")}
                            </Label>
                          </Link>
                        </Flex>
                      )}
                      {changeCustomerPermission &&
                        currentPath !== "/agents" &&
                        localStorage.getItem("selectedAgent") != null && (
                          <Flex
                            px="10px"
                            pb="5px"
                            style={{
                              gap: "5px",
                              borderBottom: "0.5px solid #303130",
                            }}
                            alignItems="center"
                            height="40px"
                          >
                            <Link
                              to={
                                "/users/" +
                                localStorage.getItem("selectedAgent")
                              }
                            >
                              <Label
                                fontSize="14px"
                                color="white"
                                marginLeft="40px"
                              >
                                {getLocalizedString("CAMBIA CLIENTE")}
                              </Label>
                            </Link>
                          </Flex>
                        )}

                      {me && (
                        <Flex
                          px="10px"
                          pb="5px"
                          style={{
                            gap: "5px",
                            borderBottom: "0.5px solid #303130",
                          }}
                          alignItems="center"
                          height="40px"
                        >
                          <Select
                            styles={{
                              control: (styles) => ({
                                ...styles,
                                border: 0,
                                borderRadius: 0,
                                backgroundColor: "transparent",
                                fontSize: "14px",
                                boxShadow: "none",
                                marginLeft: "30px",
                                color: "#fff",
                                marginRight: 10,
                              }),
                              menu: (styles) => ({
                                ...styles,
                                border: 12,
                                padding: 0,
                                borderRadius: 0,
                                fontSize: "14px",
                                marginLeft: "40px",
                                marginTop: 0,
                                marginBottom: 0,
                                boxShadow: "none",
                                color: "#232323",
                                zIndex: 10000,
                              }),
                              option: (styles) => ({
                                ...styles,
                              }),
                              placeholder: (styles) => ({
                                ...styles,
                                color: "#fff",
                              }),
                              singleValue: (styles, { data }) => ({
                                ...styles,
                                color: "#fff",
                              }),
                            }}
                            name="language"
                            components={{
                              IndicatorSeparator: () => null,
                              DropdownIndicator: (props) => (
                                <components.DropdownIndicator {...props}>
                                  <ChevronDown
                                    style={{
                                      width: 18,
                                      height: 18,
                                      color: "#fff",
                                    }}
                                  />
                                </components.DropdownIndicator>
                              ),
                            }}
                            onChange={(evt) => {
                              localStorage.setItem("B2BLanguage", evt.value);
                              navigate.push(navigate.location.pathname);
                            }}
                            options={Object.entries(languages).map(
                              ([key, language]) => ({
                                value: key,
                                label: language.name,
                              }),
                            )}
                            defaultValue={
                              languageValue ||
                              Object.entries(languages).map(
                                ([key, language]) => ({
                                  value: key,
                                  label: language.name,
                                }),
                              )[0]
                            }
                            isSearchable={false}
                          ></Select>
                        </Flex>
                      )}
                    </ul>
                  </nav>
                </IconContext.Provider>

                {currentPath !== "/privacy" && currentPath !== "/cookie" && (
                  <SwitchCustom
                    checkedIcon={false}
                    uncheckedIcon={<BsCurrencyEuro size="17px" />}
                    checked={hidePrice}
                    onChange={changeHidePrice}
                    onColor="#ffffff"
                    offColor="#ffffff"
                    height={18}
                    width={36}
                    onHandleColor="#232323"
                    offHandleColor="#232323"
                  />
                )}
              </Flex>

              <Box
                height={headerHeight}
                maxHeight={headerHeight}
                flex={isMobile ? 1 : "unset"}
                fontSize={theme.textTiny}
              >
                <Image height="100%" src={logoImage}></Image>
              </Box>

              <Flex
                height={headerHeight}
                maxHeight={headerHeight}
                justifyContent="flex-end"
                fontSize={theme.textTiny}
                flex={1}
              >
                {/* MOBILE BUTTONS */}
                <InfoButton />
                {/* CATALOGUE BUTTON */}
                {currentPath.includes("orderdetail") && (
                  <Flex
                    width={"36px"}
                    height={"50px"}
                    sx={{
                      cursor: "pointer",
                      alignItems: "center",
                      justifyContent: "center",
                      display: ["block", , , "none"],
                    }}
                    onClick={() => {
                      navigate.push("/catalogue/" + order.id);
                    }}
                  >
                    <BsColumnsGap size="20px" color="white"></BsColumnsGap>
                  </Flex>
                )}
                {/*END - CATALOGUE BUTTON */}
                {/* CART BUTTON */}
                {/* button */}
                {(currentPath.includes("draftorders") ||
                  currentPath.includes("catalogue") ||
                  currentPath.includes("cataloguesettings")) && (
                  <Box sx={{ display: ["block", , "none"] }}>
                    <MinicartButton />
                  </Box>
                )}
                {/* modal */}
                {/*END - CART BUTTON */}
                {/* END - MOBILE BUTTONS */}
                {/* LOGOUT */}
                <Flex
                  px="10px"
                  sx={{
                    gap: "5px",
                    borderBottom: "0.5px solid #303130",
                    ...(!me && {
                      pointerEvents: "none",
                      opacity: 0.7,
                    }),
                  }}
                  alignItems="center"
                  {...(isMobile && {
                    paddingLeft: "5px",
                  })}
                >
                  <Link
                    p={2}
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(userActions.logout());
                    }}
                  >
                    <Image src={logoCondensed} height={30} width={30}></Image>
                  </Link>
                </Flex>
                {/* END - LOGOUT */}
              </Flex>
            </Flex>
          </Flex>
        ) : (
          <Flex
            style={{ width: "100%", position: "relative" }}
            sx={{
              "&": {
                display: ["none", null, "block"],
              },
            }}
          >
            <Flex
              height={headerHeight}
              maxHeight={headerHeight}
              bg={theme.background}
              fontSize={"0.7em"}
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              <Flex width={1} alignItems={"center"} pl={3}>
                {me && (
                  <Avatar
                    id="avatar"
                    name={`${me.firstName} ${me.lastName}`}
                    mr={2}
                  />
                )}

                {adminDraftOrders && (
                  <>
                    <Link
                      style={{
                        color: "#fff",
                        padding: 6,
                        fontFamily: "Open Sans",
                        whiteSpace: "nowrap",
                      }}
                      to="/adminOrders"
                    >
                      <Box
                        sx={{
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {getLocalizedString("ADMIN-DRAFT ORDER")}
                      </Box>
                    </Link>
                    <NavDivider />
                  </>
                )}
                {changeAgentPermission && (
                  <>
                    <Link
                      style={{
                        color: "#fff",
                        padding: 6,
                        fontFamily: "Open Sans",
                        whiteSpace: "nowrap",
                      }}
                      to="/agents"
                    >
                      <Box
                        sx={{
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {getLocalizedString("CAMBIA AGENTE")}
                      </Box>
                    </Link>
                    <NavDivider />
                  </>
                )}
                {changeCustomerPermission &&
                  currentPath !== "/agents" &&
                  localStorage.getItem("selectedAgent") != null && (
                    <>
                      <Link
                        style={{
                          color: "#fff",
                          padding: 6,
                          fontFamily: "Open Sans",
                          whiteSpace: "nowrap",
                        }}
                        to={"/users/" + localStorage.getItem("selectedAgent")}
                      >
                        <Box
                          sx={{
                            "&:hover": {
                              textDecoration: "underline",
                            },
                          }}
                        >
                          {getLocalizedString("CAMBIA CLIENTE")}
                        </Box>
                      </Link>
                      <NavDivider />
                    </>
                  )}
                {currentPath !== "/privacy" && currentPath !== "/cookie" && (
                  <Flex padding={"4px 2px 4px"} onClick={changeHidePrice}>
                    <Box
                      sx={{
                        display: "flex",
                        padding: "2px 4px",
                        alignItems: "center",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                      onClick={changeHidePrice}
                    >
                      <Box
                        color="white"
                        fontSize="11px"
                        sx={{
                          fontFamily: "Open Sans",
                          whiteSpace: "nowrap",
                          mr: "4px",
                        }}
                      >
                        {hidePrice
                          ? getLocalizedString("SWITCH_PRICE")
                          : getLocalizedString("SWITCH_PRICE_HIDE")}
                      </Box>
                      <Box sx={{ pt: "2px" }}>
                        <SwitchCustom
                          checkedIcon={false}
                          uncheckedIcon={false}
                          checked={hidePrice}
                          onChange={changeHidePrice}
                          onColor="#888888"
                          height={15}
                          width={28}
                        />
                      </Box>
                    </Box>
                  </Flex>
                )}
              </Flex>

              <Flex justifyContent="center" alignItems="center">
                <Image
                  src={logoImage}
                  height={50}
                  style={{ objectFit: "scale-down", transform: "scale(2)" }}
                ></Image>
              </Flex>

              <Flex
                mr={3}
                className="selectdiv"
                width={1}
                height={headerHeight}
                alignItems="center"
                justifyContent="flex-end"
              >
                <Select
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      border: 0,
                      borderRadius: 0,
                      backgroundColor: "transparent",
                      fontSize: "1em",
                      boxShadow: "none",
                      color: "#fff",
                    }),
                    menu: (styles) => ({
                      ...styles,
                      border: "1px solid rgba(0,0,0,.2)",
                      padding: 0,
                      borderRadius: 0,
                      fontSize: "1em",
                      marginTop: 0,
                      marginBottom: 0,
                      boxShadow: "none",
                      zIndex: 10000,
                      maxWidth: "46px",
                    }),
                    option: (styles) => ({
                      ...styles,
                    }),
                    placeholder: (styles) => ({ ...styles, color: "#fff" }),
                    singleValue: (styles, { data }) => ({
                      ...styles,
                      color: "#fff",
                    }),
                  }}
                  name="language"
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: (props) => (
                      <components.DropdownIndicator {...props}>
                        <ChevronDown
                          style={{ width: 18, height: 18, color: "#fff" }}
                        />
                      </components.DropdownIndicator>
                    ),
                  }}
                  onChange={updateLanguage}
                  options={Object.entries(languages).map(([key, language]) => ({
                    value: key,
                    label: language.name,
                  }))}
                  defaultValue={
                    languageValue ||
                    Object.entries(languages).map(([key, language]) => ({
                      value: key,
                      label: language.name,
                    }))[0]
                  }
                  isSearchable={false}
                ></Select>
                {/* <Tooltip content="Notifiche">
                  <Link p={2} to="/notify" style={{ marginRight: "15px" }}>
                    <Notify
                      pathStyle={{ stroke: "#fff" }}
                      style={{ width: 20, height: 20 }}
                    />
                  </Link>
                </Tooltip>
                <Tooltip content="Wishlist">
                  <Link p={2} to="/wishlist" style={{ marginRight: "10px" }}>
                    <Whishlist
                      pathStyle={{ stroke: "#fff" }}
                      style={{ width: 20, height: 20 }}
                    />
                  </Link>
                </Tooltip> */}
                <Tooltip content="Info">
                  <InfoButton sx={{ marginRight: "10px" }} />
                </Tooltip>
                {showSettings && (
                  <Settings hideSettings={() => toggleSettings()} />
                )}

                <Link
                  p={2}
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(userActions.logout());
                  }}
                >
                  <Tooltip content="Service Portal">
                    <Image src={logoCondensed} height={25} width={25}></Image>
                  </Tooltip>
                </Link>
              </Flex>
            </Flex>
          </Flex>
        )}
      </Flex>
    </>
  );
};

export { Header };
